module.exports = __webpack_public_path__ + "img/banner_new_8.38fe2f3f.jpg";